module.exports = __webpack_public_path__ + "static/media/portfolio-7.ac78f581.jpg";